export class Turnstile {

    constructor ( target = '.js-turnstile', options = {} ) {
        this.target = target;

        this.options = {
            ...options
        }
    }

    init () {
        this.$turnstiles = document.querySelectorAll(this.target);

        this.$turnstiles.forEach( $turnstile => {
            turnstile.render($turnstile, {
                sitekey: $turnstile.dataset.sitekey,
                'expired-callback': this.reset.bind($turnstile),
            });
        })
    }

    reset(token) {
        turnstile.reset(this);
    }

}
